import React, { useEffect } from 'react'
import { Table,Image } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { assetsArchivesModel } from '../assetsArchivesModel'
import { IAssetsArchivesDetail } from '../assetsArchivesService'
import { useDictModel } from '@/views/base/dict/dictModel'
import { globalPrompt } from '@/components/message'
import { useNavModel } from "@/model/navModel";
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { momentFormat } from '@/utils/utils'
import { getBaseImgLookUrl } from '@/utils/constants'
import YhTootip from '@/components/YhTootip'

export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, loadData, setSelectedRowKeys } = assetsArchivesModel()
    const { getTreeNodeName,getSelectedDictOne} = useDictModel(() => [])
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    useEffect(() => {
        loadData()
    }, [])
    const detialEdit = (value) => {
        setSelectedRowKeys(value)
        let supplierEditKey = "4-2-2";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: value?.id, mode:'look'});
        } else {
            globalPrompt("modal", {
                title: "物资档案跳转详情",
                type: "warning",
                text: "您还在查看其他物资档案详情，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: value?.id, mode:'look' });
                }
            })
        }
    }
    const columns: ColumnsType<IAssetsArchivesDetail> = [
        {
            title: '序号',
            width: 60,
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '物资图片',
            width: 140,
            align: "center",
            render: (text, records) => (records.md5 ? <Image src={getBaseImgLookUrl(records.md5)}  style={{maxWidth:'50px',maxHeight:'70px'}}/> : null)
        },
        {
            title: '物资编码',
            width: 150,
            dataIndex: 'code',
            sorter:true,
            render: (t, r) => (
                <span style={{ color: '#4165E3', cursor: 'pointer' }} onClick={()=>detialEdit(r)} > {t} </span>)
        },
        {
            title: '物资名称',
            width: 160,
            dataIndex: 'name',
        },

        {
            title: '物资类型',
            width: 100,
            dataIndex: 'typeCode',
            render: (text: string) => getTreeNodeName(text) ?? ''
        },
        {
            title: '规格型号',
            width: 130,
            dataIndex: 'model',
            render: (text: string) =><YhTootip text={text} />,      
        },
        // {
        //     title: '物资条码',
        //     width: 160,
        //     dataIndex: 'barCode',
        // },
        {
            title: '单位',
            width: 90,
            dataIndex: 'unitCode',
            render: (text: string) => getSelectedDictOne(DictCodeEnmu.ASSETS_UNIT).find((item) => item.value === text)?.label ?? '',                
        },
        {
            title: '进货价',
            width: 100,
            dataIndex: 'purchasePrice',
        },
        {
            title: '品牌',
            width: 120,
            dataIndex: 'brandName',
        },

        {
            title: '创建人',
            width: 100,
            dataIndex: 'createUser',
        },
        {
            title: '创建时间',
            width: 200,
            dataIndex: 'createTime',
            render: (text) => `${momentFormat(text)}`
        },
        {
            title: '备注',
            width: 300,
            dataIndex: 'note',
        },
    ]



    return (
        <Table
            rowKey={(record) => (record.id as string)}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomCenter'],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true
            }}
            bordered
            scroll={{ x: 'max-content', y: "calc(100vh - 400px)" }}
        />
    )
}
